import {
  colors,
  fonts,
  fontSizes,
  radii,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const styles = stylex.create({
  circle: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    height: 28,
    overflow: "hidden",
    borderRadius: radii.pill,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: 1,
    color: colors.foreground,
    backgroundColor: colors.background,
  },
  picture: { width: "100%", height: "100%", objectFit: "cover" },
  pair: { display: "flex", flexShrink: 0, alignItems: "center" },
  person: {
    position: "relative",
    zIndex: 1,
    boxShadow: `0 0 0 2px ${colors.background}`,
  },
  personWithoutPhoto: { backgroundColor: colors.action },
  overlap: { marginLeft: -10 },
});
